import BreadcrumbTitle from "components/BreadcrumbTitle"
import { SaveButton } from "components/Buttons"
import ModalComponent from "components/Modals"
import PageMetaTags from "components/PageMetaTags"
import { CustomImageField, TextField } from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap"
import {
  change,
  Field,
  formValueSelector,
  initialize,
  reduxForm,
} from "redux-form"
import {
  createCategory,
  editCategory,
  getCategory,
  hideCategoryErrorModal,
  resetCategory,
} from "store/actions"
import { getFileBlob } from "utils"
import ErrorMessageModal from "./errorMessageModal"

export const required = value => (value ? undefined : "Required")

const CategoryForm = ({
  history,
  handleSubmit,
  image,
  vendorId,
  hideCategoryErrorModal,
  error,
  isCategoryErrorModalOpen,
  createCategory,
  loading,
  initializeForm,
  category,
  getCategory,
  resetCategory,
  match,
  change,
  editCategory,
}) => {
  useEffect(() => {
    if (match.params.id) {
      getCategory({ categoryId: match.params.id })
    }
    return () => {
      resetCategory()
    }
  }, [])

  useEffect(() => {
    initializeForm({
      name: category?.name,
      image: { editedImage: category?.file_url },
    })
  }, [category])

  const saveHandler = data => {
    if (match?.params?.id) {
      editCategory(match?.params?.id, {
        vendor_id: parseInt(vendorId),
        name: data?.name,
        type: 2,
        delete_file: data?.deleteImage || 0,
        order: category?.order,
        ...(data?.deleteImage
          ? {
              file:
                data?.image?.editedImage &&
                getFileBlob(data?.image?.editedImage),
            }
          : {}),
      })
    } else {
      createCategory({
        values: {
          vendor_id: parseInt(vendorId),
          name: data.name,
          type: 2,
          file:
            data?.image?.editedImage && getFileBlob(data?.image?.editedImage),
        },
        callback: () => {
          history.goBack()
        },
      })
    }
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags
          title={match?.params?.id ? "Edit Category" : "Create Category"}
        />
        <Container fluid>
          <BreadcrumbTitle
            title={match?.params?.id ? "Edit Category" : "Create New Category"}
            breadcrumbItems={[
              { title: "Dashboard" },
              {
                title: "Categories",
                link: "/categories",
              },
              {
                title: match?.params?.id ? "Edit Category" : "Create Category",
              },
            ]}
          />
          <Row className="d-flex justify-content-end mb-2">
            <Col xs="auto">
              <SaveButton
                type="button"
                color="light"
                content="Back"
                onClick={() => history.goBack()}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <form>
                <Card>
                  <CardHeader>
                    <h5>SET CATEGORY DATA</h5>
                  </CardHeader>
                  <CardBody>
                    <Row>
                      <Col xs="auto" className="mt-2">
                        <label>Name:</label>
                      </Col>
                      <Col>
                        <Field
                          name="name"
                          component={TextField}
                          validate={[required]}
                        />
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col xs="auto" className="mt-2">
                        <label>Image:</label>
                      </Col>
                      <Col xs="auto">
                        <Field
                          name="image"
                          component={CustomImageField}
                          onDelete={() => {
                            change("deleteImage", 1)
                          }}
                          onChange={() => {
                            change("deleteImage", 1)
                          }}
                        />
                      </Col>
                      <Col className="d-flex flex-row justify-content-end">
                        {image && image?.editedImage && (
                          <img
                            src={image?.editedImage ? image?.editedImage : ""}
                            alt="headerImage"
                            className="rounded avatar-xl"
                            style={{ blockSize: "auto" }}
                          />
                        )}
                      </Col>
                    </Row>
                    <Row className="my-1 d-flex justify-content-center">
                      <Col xs="auto">
                        <SaveButton
                          type="button"
                          content="Cancel"
                          color="light"
                          onClick={() => history.goBack()}
                        />
                      </Col>
                      <Col xs="auto">
                        <SaveButton
                          type="button"
                          content="Save"
                          onClick={handleSubmit(saveHandler)}
                          loading={loading}
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </form>
            </Col>
          </Row>
        </Container>
      </div>
      <ModalComponent
        open={isCategoryErrorModalOpen}
        onClose={hideCategoryErrorModal}
      >
        <ErrorMessageModal
          onClose={hideCategoryErrorModal}
          message={error?.data?.error?.name}
        />
      </ModalComponent>
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.CREATE_CATEGORY)

const mapStateToProps = state => ({
  image: selector(state, "image"),
  vendorId: state.Login.vendorId,
  isCategoryErrorModalOpen: state.Categories.isCategoryErrorModalOpen,
  error: state.Categories.error,
  loading: state.Categories.loading,
  category: state.Categories.category,
})

const mapDispatchToProps = dispatch => ({
  createCategory: values => dispatch(createCategory(values)),
  hideCategoryErrorModal: () => dispatch(hideCategoryErrorModal()),
  initializeForm: values =>
    dispatch(initialize(FORM_NAMES.CREATE_CATEGORY, values)),
  getCategory: values => dispatch(getCategory(values)),
  resetCategory: () => dispatch(resetCategory()),
  change: (field, value) =>
    dispatch(change(FORM_NAMES.CREATE_CATEGORY, `${field}`, value)),
  editCategory: (categoryId, data) => dispatch(editCategory(categoryId, data)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({ form: FORM_NAMES.CREATE_CATEGORY })(withRouter(CategoryForm)))
